import { Flex, Group, Paper, ScrollArea } from '@mantine/core';
import { SearchCategoryItem } from './SearchCategoryItem';
import { searchCategories } from './data';
export const SearchCategory: React.FC = () => {
  return <Group justify="center" w="100%" mt={{
    base: 30,
    sm: 34,
    md: 0
  }} pos="relative">
      <Paper pos="absolute" inset="0 0 0 auto" bg="linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgb(24, 28, 31) 100%)" w="6%" radius={0} style={{
      zIndex: 10
    }} />

      <ScrollArea w="100%" type="never">
        <Flex wrap="nowrap" gap={{
        base: 10,
        sm: 14
      }} justify="space-between">
          {searchCategories.map(item => <SearchCategoryItem key={item.text} {...item} />)}
        </Flex>
      </ScrollArea>
    </Group>;
};